<template>
  <v-container fluid class="container-full-bg-gray">
    <CreationObject :objectType="objectType" objectName="Empresa" :url="url" :id="company" :inputs="inputs"></CreationObject>
  </v-container>
</template>

<script>
import CreationObject from '../components/CreationObject.vue'
export default {
  components: {
    CreationObject,
  },
  props: {
    company: {
      type: [String, Number]
    }
  },
  data() {
    return {
      objectType: "Company",
      url: "companies/",
      inputs: [
        {
          "label": "NIF",
          "input": "nif",
          "type": "string",
          "readonly": false
        },
        {
          "label": "Name",
          "input": "name",
          "type": "string",
          "readonly": false
        },
        /**{
          "label": "Suppliers",
          "input": "suppliers",
          "type": "m2m",
          "readonly": false
        },
        {
          "label": "Customers",
          "input": "customers",
          "type": "m2m",
          "readonly": false
        },*/  
      ]
    };
  }
};
</script>

<style>
</style>
